<template>
    <div>
        <!--        新增打卡导入-->
        <div></div>
        <el-form :rules="rules" ref="ruleForm" :label-position="labelPosition" label-width="80px" :model="formData">
            <el-form-item label="班次" prop="vc_bcname">
                <el-select  @change="bcnameChange" style="width: 260px;" v-model="formData.vc_bcname" clearable placeholder="请选择">
                    <el-option
                            v-for="(item,index) in formData.bcList"
                            :key="index"
                            :label="item.vc_bcname"
                            :value="item.i_id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="姓名" prop="name">
                <el-select :filter-method="namesearch" style="width: 260px;"  @change="nameChange"  filterable @input.native="delaySearch" class="inputwidth" v-model="formData.name">
                    <el-option v-for="(val,index) in searchPeople" :key="index" :label="val.name+'('+val.department+')'" :value="val.id"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item :label="$t('form_date')" prop="scheduleDate">
                <el-date-picker
                        value-format="yyyy-MM-dd"
                        style="width: 260px;"
                        v-model="formData.scheduleDate"
                        type="date"
                        placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="工时" prop="whichHalf">
                <el-select style="width: 260px;" v-model="formData.whichHalf" clearable placeholder="请选择">
                    <el-option
                            v-for="item in formData.workinghours"
                            :key="item.id"
                            :label="item.value"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="margin-left: 40px">
                <el-button type="primary" @click="onSubmit">{{$t('button_save')}}</el-button>
                <el-button @click="close">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import * as API from "../api"
    import {mapActions} from "vuex";

    export default {
        name: "ScheDialog",
        props:{
            kaoqini_id:{
                type:Number
            }
        },
        data(){
            return{
                rules: {
                    name: [
                        {  required: true, message: '请选择姓名', trigger: 'change' }


                    ],
                    vc_bcname: [
                        {  required: true, message: '请选择班次', trigger: 'change' }

                    ],
                    scheduleDate: [
                        {  required: true, message: '请选择日期', trigger: 'change' }

                    ],
                    whichHalf: [
                        {  required: true, message: '请选择工时', trigger: 'change' }
                    ],

                },
                search:'',
                 options:[],
                searchPeople:[],
                currentPage:1,
                pageSize:10,
                labelPosition: 'right',//label对齐方式
                formData: {
                    vc_bcname: '',
                    name:'',
                    bcId:0,
                    bcName:'',
                    bcNote:'',
                    dkNum:0,
                    theoryHour:0,
                    // department: '',
                    whichHalf:'',
                    scheduleDate:'',
                    workEndTime:'',
                    workStartTime:'',
                    startTimeFlag:0,
                    dkRange:0,
                    endTimeFlag:0,
                    bcList:[],
                    bcdata:[],
                    workinghours:[{
                        id:0,
                        value:'上半工时'
                    },
                        {
                            id:1,
                            value:'下半工时'
                        }]
                }
            }
        },
        mounted(){
            this.getbcdetailList()

            // console.log(this.tableData)
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            namesearch(val){
                this.formData.name=val
                this.searchUser()
                // console.log(this.formData.name)
            },
            //班次输入框
            bcnameChange(val){
                // console.log(this.formData.bcList)
                let bcDataList=this.formData.bcList.filter(item=>{
                    return item.i_id==val
                })
                this.formData.bcId=bcDataList[0].i_id
                this.formData.bcName=bcDataList[0].vc_bcname
                this.formData.bcNote=bcDataList[0].vc_bcnote
                this.formData.dkNum=bcDataList[0].i_dknum
                this.formData.bcdata=bcDataList
                this.formData.dkRange=bcDataList[0].i_dktime

                // console.log(this.formData)
            },
            //延迟搜索
            delaySearch(val){
                // if(this.timer){
                //     clearTimeout(this.timer)
                // }
                // // console.log(val!==''&&val.data!==null)
                // if(val!==''&&val.data!==null){
                //     this.timer=setTimeout(()=>{
                //         if(val!==''&&val.data!==null){
                //             this.searchUser()
                //         }
                //     },500)
                // }
                // // console.log(val.data==null)
                // // console.log(val)
                // this.search=val.data
            },
            //名称搜索
            nameChange(val){
                this.search=val
                // console.log(val)
                // this.formData.userId=val
                let newname=this.searchPeople.filter((item)=>{
                    return item.id==val
                })
                // console.log(newname)
                this.formData.name=newname[0].name
                this.formData.userId=newname[0].id

            },
            close(){
                this.$emit('close')
            },
            onSubmit(){
                // console.log(thisbcdata)
                // return
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        if(this.formData.whichHalf==0){
                            this.formData.workStartTime=this.formData.scheduleDate+' '+this.formData.bcdata[0].dt_upperstart
                            this.formData.workEndTime=this.formData.scheduleDate+' '+this.formData.bcdata[0].dt_upperend
                            this.formData.startTimeFlag=this.formData.bcdata[0].i_upperstart
                            this.formData.endTimeFlag=this.formData.bcdata[0].i_upperend
                            // console.log(this.formData.workStartTime)
                            this.formData.theoryHour=this.formData.bcdata[0].i_upperhour
                            // if(bcDataList[0].i_upperstart==1 &&bcDataList[0].i_upperend==1){
                            //
                            // }else if(bcDataList[0].i_upperstart==1&&bcDataList[0].i_upperend==2){
                            //     this.formData.workerStartTime=formData.scheduleDate+bcDataList[0].dt_upperstart
                            //     let time = new Date(this.formData.workEndTime);
                            //     let resultTime = time. getTime;
                            //     let resultTimeStr = resultTime + 1000 * 60 * 60 * 24 * cycle;
                            // }

                        }else {
                            this.formData.workStartTime=this.formData.scheduleDate+' '+this.formData.bcdata[0].dt_lowerstart
                            this.formData.workEndTime=this.formData.scheduleDate+' '+this.formData.bcdata[0].dt_lowerend
                            this.formData.startTimeFlag=this.formData.bcdata[0].i_lowerstart
                            this.formData.endTimeFlag=this.formData.bcdata[0].i_lowerend
                            this.formData.theoryHour=this.formData.bcdata[0].i_lowerhour

                            // if(bcDataList[0].i_lowerstart==1 &&bcDataList[0].i_lowerend==1){
                            //     this.formData.workerStartTime=formData.scheduleDate+bcDataList[0].dt_lowerstart
                            //     this.formData.workEndTime=formData.scheduleDate+bcDataList[0].dt_lowerend
                            // }

                        }
                        if(this.formData.startTimeFlag==2){
                            let time = new Date(this.formData.workStartTime);
                            let resultTime = time. getTime;
                            let resultTimeStr = resultTime + 1000 * 60 * 60 * 24 * 1;
                            let endTime = new Date();
                            this.formData.workStartTime=endTime. setTime(resultTimeStr);
                        }
                        if(this.formData.endTimeFlag==2){
                            let time = new Date(this.formData.workEndTime);
                            let resultTime = time. getTime;
                            let resultTimeStr = resultTime + 1000 * 60 * 60 * 24 * 1;
                            let endTime = new Date();
                            this.formData.workEndTime=endTime. setTime(resultTimeStr);

                        }
                        this.$emit('saveSche',this.formData)
                    } else {
                        // console.log('error submit!!');
                        return false;
                    }
                });

            },
            //搜索查询
            async searchUser() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    keyname:this.formData.name
                }
                let res = await API.searchUser(params);
                if (res.code == 1) {
                    this.searchPeople=res.data
                    // console.log(res.data)
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //班次明细列表
            async getbcdetailList(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                };
                let param={
                    page_size:1,
                    page_count:999,
                    i_kqtcid:this.kaoqini_id
                }
                let res=await API.getbcdetailList(param)
                if(res.code==1){
                    this.formData.bcList=res.data
                    // console.log(this.tableData)
                } else if (res.code == -2) {
                    this.$router.push('/login')
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
            },
        }
    }
</script>

<style lang="scss" scoped>

</style>